import { Comment, RotatingSquare } from "react-loader-spinner";
import { Notification } from "../../types/notification";
import { Order } from "../../types/orders";
import NotificationSnippetCard from "./NotificationSnippetCard";
import OrderSnippetCard from "./OrderSnippetCard";

interface Props {
  orders: Order[];
  notifications: Notification[];
  loadingNotifications: boolean;
  loadingOrders: boolean;
}

const LatestActivityCard = ({
  orders,
  notifications,
  loadingNotifications,
  loadingOrders,
}: Props) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
      <h3 className="font-bold text-lg mb-6">Latest Activity</h3>
      <div className="grid grid-cols-2 gap-12">
        <div className="space-y-4 ">
          <h3 className="text-md font-semibold text-emerald-800">Orders</h3>
          {loadingOrders ? (
            <div className="flex items-center justify-center">
              <RotatingSquare
                visible={true}
                height="100"
                width="100"
                color="#1abd69"
                ariaLabel="rotating-square-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <OrderSnippetCard orders={orders} />
          )}
        </div>
        <div className="space-y-4">
          <h3 className="text-md font-semibold text-emerald-800">
            Notifications
          </h3>
          {loadingNotifications ? (
            <div className="flex items-center justify-center">
              <Comment
                visible={true}
                height="80"
                width="80"
                ariaLabel="comment-loading"
                wrapperStyle={{}}
                wrapperClass="comment-wrapper"
                color="#fff"
                backgroundColor="#1abd69"
              />
            </div>
          ) : (
            <NotificationSnippetCard notifications={notifications} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LatestActivityCard;
